export default "__VITE_ASSET__D2ef5qGJ__"